import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { whatsappServersService } from '../api/whatsapp-servers.service';

export function useWhatsAppServersListQuery() {
  return useQuery({
    queryKey: queryKeys.whatsappServers.list(),
    queryFn: () => whatsappServersService.list(),
  });
}

export function useWhatsAppServersStatsQuery() {
  return useQuery({
    queryKey: queryKeys.whatsappServers.stats(),
    queryFn: () => whatsappServersService.getStats(),
  });
}
